import React from 'react'
import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'

/**
 * AddConfigButton component
 * A button component to add a new configuration.
 * 
 * @param {Object} props - Props for the button component.
 * @param {Function} props.onClick - Click handler function.
 * @param {Object} props.sx - Style overrides for the button.
 * @returns {JSX.Element} The rendered button component.
 */
export const AddConfigButton = (props) => (
  <Button
    color="primary"
    startIcon={<AddIcon />}
    onClick={props?.onClick}
    variant="contained"
    sx={{ zIndex: '1', whiteSpace: 'nowrap', ...props?.sx }}
  >
    Add Config
  </Button>
)

